import React, { FC } from 'react';
import {
  Filter,
  SelectInput,
  DateInput,
  TextInput,
  FilterProps,
  ReferenceInput,
} from 'react-admin';
import { LazyReferenceInput } from 'components/LazyAutoCompleteInput';
import { UserRoleMultiReferenceInput } from 'components/UserRoleMultiReferenceInput';

export const RepairPayablesSheetFilter: FC<FilterProps> = props => (
  <Filter {...props}>
    <UserRoleMultiReferenceInput
      source="createdById"
      roles={['Supervisor', 'SuperAdmin', 'RegionalAdmin']}
      referenceForGetOne="user"
      data-cy="BumpoutTimesheetsFilterSupervisor"
      resettable
      alwaysOn
    />
    <DateInput
      label="Repair On or After"
      source="repairPaymentDate||$gte"
      alwaysOn
      data-cy="RepairPayablesSheetFilterDatePaidBegin"
    />
    <DateInput
      label="Repair On or Before"
      source="repairPaymentDate||$lte"
      alwaysOn
      data-cy="RepairPayablesSheetFilterDatePaidEnd"
    />
    <LazyReferenceInput
      label="Builder"
      source="builderId"
      reference="builder"
      resettable
      alwaysOn
      data-cy="RepairPayablesSheetFilterBuilder"
      filterToQuery={value => (value ? { name: value } : {})}
      sort={{ field: 'name', order: 'ASC' }}
      optionText="name"
      optionValue="id"
    />
    <LazyReferenceInput
      label="Subdivision"
      source="subdivisionId"
      reference="subdivision"
      data-cy="RepairPayablesSheetFilterSubdivision"
      resettable
      filterToQuery={value => (value ? { name: value } : {})}
      sort={{ field: 'name', order: 'ASC' }}
      optionText="name"
      optionValue="id"
    />
    <TextInput
      label="Community Phase"
      source="jobCommunityPhase||$cont"
      resettable
      alwaysOn
      data-cy="RepairPayablesSheetFilterCommunityPhase"
    />
    <TextInput
      label="Lot"
      source="jobLot||$eq"
      resettable
      alwaysOn
      data-cy="RepairPayablesSheetFilterLot"
    />
    <TextInput
      label="Block"
      source="jobBlock||$eq"
      resettable
      alwaysOn
      data-cy="RepairPayablesSheetFilterBlock"
    />
    <LazyReferenceInput
      label="Contractor"
      source="contractorId"
      reference="contractor"
      resettable
      alwaysOn
      data-cy="RepairPayablesSheetFilterContractor"
      filterToQuery={value => (value ? { name: value } : {})}
      sort={{ field: 'name', order: 'ASC' }}
      optionText="name"
      optionValue="id"
    />
    <ReferenceInput
      label="Repair Type"
      data-cy="RepairPayablesSheetFilterPhase"
      source="repairId"
      reference="repair"
      perPage={Number.MAX_SAFE_INTEGER}
      resettable
      alwaysOn
      allowEmpty={false}
      sort={{ field: 'repairType', order: 'ASC' }}
    >
      <SelectInput optionText="repairType" optionValue="id" />
    </ReferenceInput>
    <SelectInput
      source="status||$eq"
      label="Status"
      alwaysOn
      data-cy="RepairPayablesSheetFilterIsPaid"
      choices={[
        { val: 'Paid', text: 'Paid' },
        { val: 'Unpaid', text: 'Unpaid' },
      ]}
      emptyText="All"
      optionValue="val"
      optionText="text"
    />
  </Filter>
);
